import { Workflow } from "@finway-group/shared/lib/models"
import { useSelector } from "react-redux"
import store from "Shared/store"
import { RootState } from "Shared/store/rootState.interface"

export const useWorkflows = (searchValue?: string) => {
    let workflows = useSelector(({ workflows: { items } }: RootState) => items)
    return filterWorkflows(workflows, searchValue)
}

export const getWorkflowsFromStore = (searchValue?: string) => {
    const workflows = store.getState().workflows.items
    return filterWorkflows(workflows, searchValue)
}

const filterWorkflows = (workflows: any[], searchValue: any): Workflow[] => {
    if (searchValue) {
        workflows = workflows?.filter((workflow: Workflow) => workflow.name.toLowerCase().includes(searchValue.toLowerCase()))
    }

    return workflows.map((workflow) => new Workflow(workflow)).sort((workflowA: any, workflowB: any) => workflowA.order - workflowB.order)
};

export const useWorkflow = () => useSelector(({ workflows: { item } }: RootState) => item)
